import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'luci-global-search',
  templateUrl: './luci-global-search.component.html',
  styleUrls: ['./luci-global-search.component.scss']
})
export class LuciGlobalSearchComponent implements OnInit {

  @Input() placeholder: string;
  @Input() searchText: string;
  @Input() tableHeader: any = [];
  @Input() tableData: any[] = [];

  selectedTab: any = {};
  searchQuery = '';

  constructor() {}

  ngOnInit() {
  }
}
